import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LOKALISE_ENV_ENABLED, LOKALISE_USER_ENABLED } from './provider';
import { LokaliseService } from './lokalise.service';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false,
})
export class LokaliseTranslatePipe
  extends TranslatePipe
  implements PipeTransform
{
  private enabledEnvToken = inject(LOKALISE_ENV_ENABLED);
  private enabledUserToken = inject(LOKALISE_USER_ENABLED);
  private lokaliseService = inject(LokaliseService);

  transform(value: any, ...args: any[]): any {
    const translation = super.transform(value, ...args);

    if (!this.enabledEnvToken || !this.enabledUserToken) {
      // Return translation, Lokalise script is not enabled
      return translation;
    }

    if (typeof translation === 'string') {
      this.lokaliseService.translationAdded.next();
      return '{.' + value.replaceAll('.', '::') + '.}';
    }

    if (Array.isArray(translation)) {
      return Array.from(Array(translation.length)).map(
        (_, index) => `{.${value.replaceAll('.', '::')}::${index}.}`
      );
    }

    return translation;
  }
}
